import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  stampSection: () => css`
    margin: 0 21px 0 21px;
  `,
})

export default useStyles
